(function () {
  'use strict';

  function ChecklistVdrivers() {
    return {
      templateUrl: `configuracoes/vdrivers/subpaginas/checklist/checklist-vdrivers.tpl.html`,
      controller(ConfigVdriversService) {
        this.service = ConfigVdriversService;
      },
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular
    .module('SubpaginasVdrivers')
    .directive('checklistVdrivers', ChecklistVdrivers);
}());
